export const columns = [
  {
    title: "节点名称",
    dataIndex: "currentNodeSnapshootName",
    width: 100,
    key: "currentNodeSnapshootName",
  },
  {
    title: "节点状态",
    dataIndex: "flowStatusDesc",
    width: 150,
    key: "flowStatusDesc",
  },
  {
    title: "审批意见",
    dataIndex: "remark",
    width: 180,
    key: "remark",
  },
  {
    title: "提交人",
    dataIndex: "createName",
    width: 110,
    key: "createName",
  },
  {
    title: "审批人（下一节点）",
    width: 150,
    dataIndex: "nextTenantUserRealName",
    key: "nextTenantUserRealName",
    slots: { customRender: "nextTenantUserRealName" },
  },
  {
    title: "提交时间",
    width: 200,
    dataIndex: "createTime",
    key: "createTime",
  },
];
